import { localStorageKeys } from 'src/constants/localStorageKeys'

export const getApiKey = () => {
  return localStorage.getItem(localStorageKeys.accessToken) || ''
}
